import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";

export const getIssueMPMethods = {
  // overall final MP/marker value
  getIssueMPMarkerValue: (issue, lineId) => {
    // prefer issue Marker
    let issueMarker = getIssueMPMethods.getIssueMarker(issue);
    return issueMarker ? issueMarker : getIssueMPMethods.getIssueFinalMP(issue, lineId);
  },
  // marker value
  getIssueMarker: (issue) => {
    let start = issueUnitMpMarkerSingleItems.getStartMarker(issue);
    let end = issueUnitMpMarkerSingleItems.getEndMarker(issue);
    return start && end ? `${start},${end}` : start ? `${start} - N/A` : end ? `N/A - ${end}` : "";
  },
  getIssueMarkerStart: (issue) => {
    let start = issueUnitMpMarkerSingleItems.getStartMarker(issue);
    return start;
  },
  getIssueMarkerEnd: (issue) => {
    let end = issueUnitMpMarkerSingleItems.getEndMarker(issue);
    return end;
  },
  // milepost methods:
  getIssueFinalMP: (issue, lineId) => {
    let issueMp = getIssueMPMethods.getIssueMP(issue, lineId);
    return issueMp ? issueMp : unitMPMarkerItems.getUnitMP(issue.unit, lineId);
  },
  getIssueMP: (issue, lineId) => {
    const start = issueUnitMpMarkerSingleItems.getIssueStartMP(issue);
    const end = issueUnitMpMarkerSingleItems.getIssueEndMP(issue);
    // preifx to be added to startEnd
    let startPrefix = LocPrefixService.getPrefixMp(start, lineId);
    let endPrefix = LocPrefixService.getPrefixMp(end, lineId);
    return evalCondition([
      { condition: () => start && end && `${startPrefix + start},${endPrefix + end}` },
      { condition: () => start && startPrefix + start },
      { condition: () => end && endPrefix + end },
    ]);
  },
  getIssueFinalStartMP: (issue, lineId, prefix) => {
    let start = issueUnitMpMarkerSingleItems.getIssueStartMP(issue);
    if (!start) start = issueUnitMpMarkerSingleItems.getUnitStartMP(issue.unit);
    let startPrefix = LocPrefixService.getPrefixMp(start, lineId);
    return prefix ? startPrefix + start : start;
  },
  getIssueFinalEndMP: (issue, lineId, prefix) => {
    let end = issueUnitMpMarkerSingleItems.getIssueEndMP(issue);
    if (!end) end = issueUnitMpMarkerSingleItems.getUnitEndMP(issue.unit);
    let endPrefix = LocPrefixService.getPrefixMp(end, lineId);
    return prefix ? endPrefix + end : end;
  },
};

export const unitMPMarkerItems = {
  // unit items
  getUnitMpMarkerValues: (unit) => {
    const unitMarker = unitMPMarkerItems.getUnitMarker(unit);
    return unitMarker ? unitMarker : unitMPMarkerItems.getUnitMP(unit);
  },
  getUnitMP: (unit, lineId) => {
    const start = issueUnitMpMarkerSingleItems.getUnitStartMP(unit);
    const end = issueUnitMpMarkerSingleItems.getUnitEndMP(unit);
    // preifx to be added to startEnd
    let startPrefix = LocPrefixService.getPrefixMp(start, lineId);
    let endPrefix = LocPrefixService.getPrefixMp(end, lineId);
    return evalCondition([
      { condition: () => start && end && start == end && startPrefix + start },
      { condition: () => start && end && `${startPrefix + start},${endPrefix + end}` },
      { condition: () => start && startPrefix + start },
      { condition: () => end && endPrefix + end },
    ]);
  },
  getUnitMarker: (unit) => {
    const start = issueUnitMpMarkerSingleItems.getItemStartMarker(unit);
    const end = issueUnitMpMarkerSingleItems.getItemEndMarker(unit);
    return start && end ? `${start},${end}` : start ? `${start} - N/A` : end ? `N/A - ${end}` : "";
  },
  getUnitMarkerMPStart: (unit, lineId) => {
    const start = issueUnitMpMarkerSingleItems.getItemStartMarker(unit);
    const end = issueUnitMpMarkerSingleItems.getItemEndMarker(unit);
    if (start || end) return start || "N/A";
    let startPrefix = LocPrefixService.getPrefixMp(start, lineId);
    return startPrefix + issueUnitMpMarkerSingleItems.getUnitStartMP(unit);
  },
  getUnitMarkerMPEnd: (unit, lineId) => {
    const start = issueUnitMpMarkerSingleItems.getItemStartMarker(unit);
    const end = issueUnitMpMarkerSingleItems.getItemEndMarker(unit);
    if (start || end) return end || "N/A";

    let endPrefix = LocPrefixService.getPrefixMp(end, lineId);
    return endPrefix + issueUnitMpMarkerSingleItems.getUnitEndMP(unit);
  },
};
export const issueUnitMpMarkerSingleItems = {
  // single marker
  getStartMarker: (issue) =>
    issueUnitMpMarkerSingleItems.getItemStartMarker(issue)
      ? issue.startMarker
      : issueUnitMpMarkerSingleItems.getItemStartMarker(issue.unit),
  getEndMarker: (issue) =>
    issueUnitMpMarkerSingleItems.getItemEndMarker(issue) ? issue.endMarker : issueUnitMpMarkerSingleItems.getItemEndMarker(issue.unit),
  // single item marker
  getItemStartMarker: (item) => (item && item.startMarker && item.startMarker.trim()) || "",
  getItemEndMarker: (item) => (item && item.endMarker && item.endMarker.trim()) || "",

  // issue single item MP
  getIssueStartMP: (issue) => (issue && issue.startMp ? issue.startMp : ""),
  getIssueEndMP: (issue) => (issue && issue.endMp ? issue.endMp : ""),
  // unit single item Unit MP
  getUnitStartMP: (unit) => (unit && unit.start ? unit.start : ""),
  getUnitEndMP: (unit) => (unit && unit.end ? unit.end : ""),
};

function evalCondition(conditions) {
  for (const con of conditions) {
    let result = con.condition();
    if (result) return result;
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/components/Common/services/mileposts.js